import React, { useState, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Uploadfiles from "./UploadFiles";
import ViewFiles from "./ViewFiles";
import driverApi from "Services/Driver";

const Documents = ({ driverId, setsubmitButton, setSkipButton }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  const [row, setRow] = useState([]);
  const [uploadFilesModal, setUploadFilesModal] = useState(false);
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [documentData, setDocumentData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsInitialData, setDocumentsInitialData] = useState([]);

  const handleOpenUploadFilesModal = (rowData) => {
    setDocumentId(rowData?.documentId);
    setDocumentData(rowData);
    setUploadFilesModal(true);
  };

  const handleCloseUploadFilesModal = () => {
    getDriverDocuments();
    setUploadFilesModal(false);
  };

  const handleCloseViewFilesModal = () => {
    getDriverDocuments();
    setViewFilesModal(false);
  };

  const handleOpenViewFilesModal = (rowData) => {
    setDocumentId(rowData?.documentId);
    setDocumentData(rowData);
    setViewFilesModal(true);
  };

  const getDriverDocuments = () => {
    if (!driverId) return;
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDriverDocumentsData(res?.data?.data?.driverDocuments || []);
        setDocumentsInitialData([
          {
            id: 1,
            sno: "1",
            documentId: 0,
            documentType: "Proof of address",
            documentTypeAlias: "PROOF OF ADDRESS",
            file: "",
            status: "No document found",
          },
        ]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch documents",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    driverApi.getDriverDocumentsByDriverId(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    getDriverDocuments();
  }, [driverId]);

  const handleDeleteDocument = (rowData) => {
    if (window.confirm("Do you want to Delete?")) {
      dispatch(showLoader("Loading please wait..."));
      const data = {
        document_id: rowData?.documentId,
        user_id: driverId,
      };

      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: "Document deleted successfully",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
              variant: "success",
            })
          );
        }
        getDriverDocuments();
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Failed to delete document",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      };

      driverApi.deleteDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    if (documentsInitialData.length > 0) {
      const combinedArray = documentsInitialData.map((item1) => {
        const matchingDocument = driverDocumentsData.find((item2) => {
          return item1.documentTypeAlias === item2.documentType;
        });

        const documentId = matchingDocument ? matchingDocument._id : 0;
        const documentPath = matchingDocument ? (matchingDocument.documentPath ? matchingDocument.documentPath : "") : "";
        const status = matchingDocument ? (matchingDocument.documentPath ? matchingDocument.status : "NO DOCUMENT") : "NO DOCUMENT";

        return {
          ...item1,
          documentId,
          file: documentPath,
          status,
        };
      });
      setRow(combinedArray);
    }
  }, [driverDocumentsData, documentsInitialData]);

  const getStatusClass = (status) => {
    if (status === "NO DOCUMENT" || status === "No document found") {
      return `${classes.statusBadge} ${classes.statusNoDocument}`;
    }
    if (status === "APPROVED" || status === "Uploaded") {
      return `${classes.statusBadge} ${classes.statusUploaded}`;
    }
    return `${classes.statusBadge} ${classes.statusPending}`;
  };

  return (
    <Box className={classes.root}>
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Document Type</TableCell>
              <TableCell className={classes.tableHeaderCell}>Status</TableCell>
              <TableCell className={classes.tableHeaderCell} align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {row.map((item, index) => (
              <TableRow key={item.id} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{index + 1}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {item.documentType}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <span className={getStatusClass(item.status)}>{item.status}</span>
                </TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <Box className={classes.actionBtnWrapper} sx={{ justifyContent: "flex-end" }}>
                    {item.file === "" ? (
                      <Button
                        className={classes.uploadButton}
                        variant="contained"
                        onClick={() => handleOpenUploadFilesModal(item)}
                      >
                        Upload
                      </Button>
                    ) : (
                      <>
                        <Button
                          className={classes.viewButton}
                          variant="outlined"
                          onClick={() => handleOpenViewFilesModal(item)}
                        >
                          View
                        </Button>
                        <Button
                          className={classes.deleteButton}
                          variant="contained"
                          onClick={() => handleDeleteDocument(item)}
                        >
                          Delete
                        </Button>
                      </>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {row.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No documents found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Uploadfiles
        openDialog={uploadFilesModal}
        handleClose={handleCloseUploadFilesModal}
        driverId={driverId}
        documentId={documentId}
        documentData={documentData}
      />
      <ViewFiles
        openDialog={viewFilesModal}
        handleClose={handleCloseViewFilesModal}
        driverId={driverId}
        documentId={documentId}
        documentData={documentData}
      />
    </Box>
  );
};

export default Documents;
